<ng-template #choiceTemplate let-item="item" [typedTemplate]="this.typeUserToken">
  <div class="flex-start g-space-sm">
    <cam-user-logo [user]="item" size="md" defaultType="font"></cam-user-logo>{{ item.firstName }} {{ item.lastName }}
  </div>
</ng-template>
